import { controls, grouped } from "../controls";
const copy_client_starter_datas = {
  label: "Copy Client Starter Datas",
  pageLabel: "Copy Client Starter Datas", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Client" }),
    ...controls.oc({ tab: "filter", c: "Client", placeHolder: "Client Code", name: "CopyClientStarterData-from_client-client_code", fastpath: "clients" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "CopyClientStarterData-from_client-client_display" }),
    ...controls.displayText({ tab: "filter", label: "Select Model" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "model_code", maxlength: 30 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Client" }),
    ...controls.oc({ tab: "filter", c: "Client", placeHolder: "Client Code", name: "CopyClientStarterData-to_client-client_code", fastpath: "clients" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "CopyClientStarterData-to_client-client_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "From Client", star: false }),
    ...controls.oc({ tab: "general", c: "Client", placeHolder: "From Client", name: "from_client_code", fastpath: "clients", displayData: { client_display: "from_client_display" }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "from_client_display" }),
    ...controls.displayText({ tab: "general", label: "Select Model" }),
    ...controls.oc({ tab: "general", c: "CopyClientStarterData", placeHolder: "Select Model", name: "model_code", displayData: { model_display: "model_display" }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "model_display" }),
    ...controls.displayText({ tab: "general", label: "To Client", star: false }),
    ...controls.oc({ tab: "general", c: "Client", placeHolder: "To Client", name: "to_client_code", fastpath: "clients", displayData: { client_display: "to_client_display" }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "to_client_display" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Copy Client Starter Datas",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Select Model", accessor: "model_code", },
      { Header: "Client", accessor: "CopyClientStarterData-from_client-client_display", },
      { Header: "Client", accessor: "CopyClientStarterData-to_client-client_display", },
    ]
  }
};
export default copy_client_starter_datas;